var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSparkles = function SvgSparkles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sparkles_svg__sparkles_svg__clip0_810_90049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.333 15A1.667 1.667 0 0115 16.666 1.667 1.667 0 0116.667 15 1.666 1.666 0 0115 13.333 1.666 1.666 0 0113.333 15zm0-10A1.666 1.666 0 0115 6.666 1.667 1.667 0 0116.667 5 1.666 1.666 0 0115 3.333 1.667 1.667 0 0113.333 5zM7.5 15a5 5 0 015-5 5 5 0 01-5-5 5 5 0 01-5 5 5 5 0 015 5z",
    stroke: "url(#sparkles_svg__sparkles_svg__paint0_linear_810_90049)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkles_svg__sparkles_svg__paint0_linear_810_90049",
    x1: 9.583,
    y1: 3.333,
    x2: 9.583,
    y2: 16.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#852FD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#106EE8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sparkles_svg__sparkles_svg__clip0_810_90049"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgSparkles;